import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `currentColor` : `var(--color-${color})`;
};
const SvgBlueskyColorIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 64 57"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path fill={getFillColor(props.color) === "currentColor" ? `var(--color-bluesky)` : getFillColor(props.color)}
      d="M14.477 4.735C21.57 10.105 29.199 20.99 32 26.832c2.801-5.842 10.43-16.728 17.523-22.097 5.118-3.874 13.41-6.871 13.41 2.667 0 1.905-1.083 16.002-1.718 18.29-2.208 7.957-10.255 9.987-17.413 8.758 12.512 2.147 15.694 9.26 8.82 16.371-13.054 13.507-18.763-3.389-20.227-7.718-.268-.794-.393-1.165-.395-.85-.002-.315-.127.056-.396.85-1.462 4.33-7.171 21.226-20.227 7.718-6.874-7.112-3.691-14.224 8.821-16.37-7.158 1.228-15.205-.802-17.413-8.759-.635-2.288-1.719-16.385-1.719-18.29 0-9.538 8.293-6.54 13.41-2.667Z"
    />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgBlueskyColorStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgBlueskyColorIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const BlueskyColorIcon: any = SvgBlueskyColorStyle;
export default BlueskyColorIcon;
